import axios from 'axios';

export default {
  getEvent({ commit }, eventId) {
    commit('global/setLoadingState', true, { root: true });
    return new Promise((resolve, reject) => {
      return axios.get(`/ajax/web-forms/events/${eventId}`)
        .then(({ data }) => {
          commit('updateEventContent', data.data);

          const { type, questions } = data.data;

          commit('forms/setFormType', type, { root: true });
          commit('forms/setFormQuestions', questions, { root: true });

          commit('global/setLoadingState', false, { root: true });
          return resolve(data.data);
        }).catch((error) => {
          return reject(error.response.data);
        });
    });
  },

  deleteEvent({ commit }, eventId) {
    return new Promise((resolve, reject) => {
      commit('global/setLoadingState', true, { root: true });
      return axios.delete(`/ajax/web-forms/events/${eventId}`)
        .then((response) => {
          commit('global/setLoadingState', false, { root: true });
          return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });
    });
  },

  resetFlows({ commit }, eventId) {
    return new Promise((resolve, reject) => {
      commit('global/setLoadingState', true, { root: true });
      return axios.delete(`/ajax/web-forms/events/${eventId}/screen-flow`)
        .then((response) => {
          return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });
    });
  },

  resetScores({ commit }, eventId) {
    return new Promise((resolve, reject) => {
      commit('global/setLoadingState', true, { root: true });
      return axios.delete(`/ajax/web-forms/events/${eventId}/scores`)
        .then((response) => {
          return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });
    });
  },

  deleteTemplate({ commit }, templateId) {
    return new Promise((resolve, reject) => {
      commit('global/setLoadingState', true, { root: true });
      return axios.delete(`/events/${templateId}`)
        .then((response) => {
          commit('global/setLoadingState', false, { root: true });
          return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });
    });
  },

  createEvent({ commit }, { payload }) {
    return new Promise((resolve, reject) => {
      return axios.post('/ajax/web-forms/events/create', payload)
        .then(({ data }) => {
          commit('updateEventContent', data.data);
          return resolve(data.data);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },
  updateEvent({ commit }, payload) {
    return new Promise((resolve, reject) => {
      return axios.put(`/ajax/web-forms/events/${payload.id}`, payload)
        .then(({ data }) => {
          commit('updateEventContent', data.data);
          return resolve(data.data);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },

  duplicateEvent(store, { eventId, payload }) {
    return new Promise((resolve, reject) => {
      return axios.post(`/ajax/web-forms/events/${eventId}/duplicate`, payload).then((data) => {
        return resolve(data);
      })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },

  saveEventSettings({ commit }, payload) { // companySettings
    return new Promise((resolve, reject) => {
      return axios.post('/ajax/web-forms/events/company-overall-settings', payload)
        .then(({ data }) => {
          commit('updateDefaultEventColours', data.meta.company_settings);
          return resolve(data.data);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },

  sendEmailTest(store, payload) {
    return new Promise((resolve, reject) => {
      return axios.post(`/ajax/web-forms/events/${payload.id}/send-test-to-automation`, payload)
        .then(({ data }) => {
          return resolve(data.data);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },

  getInteractionTypes({ commit }) {
    return axios.get('/ajax/web-forms/events/company-interaction-types')
      .then(({ data }) => {
        commit('setInteractionTypes', data.data);
      });
  },

  getEventRecords(context, eventId) {
    return new Promise((resolve, reject) => {
      return axios.get(`/ajax/web-forms/events/${eventId}/records`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },

  getSingleEventRecord({ commit }, { eventId, recordId }) {
    return new Promise((resolve, reject) => {
      return axios.get(`/ajax/web-forms/events/${eventId}/records/${recordId}`)
        .then(({ data }) => {
          commit('updateEventContent', { name: data.meta.eventName });
          return resolve(data);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  sendData({ commit }, { eventId, integrationId }) {
    return new Promise((resolve, reject) => {
      return axios.get(`/ajax/web-forms/events/${eventId}/integrations/${integrationId}/resend-data`)
        .then(({ data }) => {
          return resolve(data.data);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },
  createIntegration({ commit }, { eventId, payload }) {
    return new Promise((resolve, reject) => {
      return axios.post(`/ajax/web-forms/events/${eventId}/integrations/`, payload)
        .then(({ data }) => {
          commit('updateIntegrations', data);
          return resolve(data);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },

  updateIntegration(store, { eventId, integrationId, payload }) {
    return new Promise((resolve, reject) => {
      return axios.put(`/ajax/web-forms/events/${eventId}/integrations/${integrationId}`, payload)
        .then(({ data }) => {
          return resolve(data.data);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },

  togglePauseIntegration(store, { eventId, integrationId, paused }) {
    return new Promise((resolve, reject) => {
      return axios.put(`/ajax/web-forms/events/${eventId}/integrations/${integrationId}/toggle-to-pause-or-activate
      `, { is_paused: paused })
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },

  getIntegrationsList({ commit }, { eventId }) {
    return new Promise((resolve, reject) => {
      return axios.get(`/ajax/web-forms/events/${eventId}/integrations`)
        .then(({ data }) => {
          commit('updateIntegrations', data);
          return resolve(data);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },

  getIntegration(store, { eventId, integrationId }) {
    return new Promise((resolve, reject) => {
      return axios.get(`/ajax/web-forms/events/${eventId}/integrations/${integrationId}`)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },

  deleteIntegration({ commit }, { eventId, integrationId }) {
    return new Promise((resolve, reject) => {
      commit('global/setLoadingState', true, { root: true });
      return axios.delete(`/ajax/web-forms/events/${eventId}/integrations/${integrationId}`)
        .then(({ data }) => {
          commit('updateIntegrations', data);
          return resolve(data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });
    });
  },

  deleteEventRecords({ commit }, { eventId, eventRecordIds }) {
    return new Promise((resolve, reject) => {
      commit('global/setLoadingState', true, { root: true });
      return axios.delete(`/ajax/web-forms/events/${eventId}/records/delete`, { data: { ids: eventRecordIds } })
        .then((response) => {
          commit('global/setLoadingState', false, { root: true });
          return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response.data);
        });
    });
  },
  exportEventRecords(context, { eventId, typeOfLinkForFileUploadDownloads }) {
    return new Promise((resolve, reject) => {
      return axios.get(`/events/${eventId}/records/export?type-of-link-to-download-files-of-file-upload-questions=${typeOfLinkForFileUploadDownloads}`)
        .then((response) => {
          return resolve(response.data);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },

  generateEventEmbedCode(context, { eventId, payload }) {
    return new Promise((resolve, reject) => {
      return axios.post(`/ajax/web-forms/events/${eventId}/generate-embedded-code`, payload)
        .then(({ data }) => {
          return resolve(data);
        })
        .catch((error) => {
          return reject(error.response);
        });
    });
  },

  getWebforms() {
    return new Promise((resolve, reject) => {
      return axios.get('/ajax/web-forms/events/index')
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  getRedirectSettings(store, eventID) {
    return new Promise((resolve, reject) => {
      return axios.get(`/ajax/web-forms/events/${eventID}/on-completion-redirect-to-web-form`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  saveRedirectSettings({ commit }, { eventID, payload }) {
    return new Promise((resolve, reject) => {
      return axios.post(`/ajax/web-forms/events/${eventID}/on-completion-redirect-to-web-form`, payload)
        .then((response) => {
          commit('updateEventPreviewUrl', response.data.data.updatedPreviewUrl);
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  getEventScores(store, eventID) {
    return new Promise((resolve, reject) => {
      return axios.get(`/ajax/web-forms/events/${eventID}/scores`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.reponse.data);
        });
    });
  },

  saveScoresSettings(store, { eventID, payload }) {
    return new Promise((resolve, reject) => {
      return axios.post(`/ajax/web-forms/events/${eventID}/scores`, payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },

  getScreenFlow(store, eventID) {
    return new Promise((resolve, reject) => {
      return axios.get(`/ajax/web-forms/events/${eventID}/screen-flow`)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.reponse.data);
        });
    });
  },

  saveScreenFlowSettings(store, { eventID, payload }) {
    return new Promise((resolve, reject) => {
      return axios.post(`/ajax/web-forms/events/${eventID}/screen-flow`, payload)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error.response.data);
        });
    });
  },
};
